import { AfterViewInit, Component, Inject } from '@angular/core';
import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';
import { Store } from '@ngrx/store';
import { GenericListType, LoadMoreQuery } from '../../../common/components/lists/generic-list.component';
import { AppState } from '../../../store';
import {
  closeMembersModal,
  getMembersList,
  loadMoreMembersList,
  openMembersModal,
} from '../../store/members/members.actions';
import {
  selectAreAllMembersLoadedFlag,
  selectMembers,
  selectMembersErrorFlag,
  selectMembersIsModalOpenFlag,
  selectMembersLoadingFlag,
} from '../../store/members/members.selectors';
import { PermissionsService } from '../../../common/services/permissions.service';
import { QueryParamsMembersList } from '../../../common/helper/query-params-generic-list.helper';

@Component({
  selector: 'members-list',
  template: `
    <generic-list
      [type]="type"
      [items]="members$ | async"
      [isLoading]="membersLoading$ | async"
      [hasNewButton]="true"
      (createClick)="openCreateModal()"
      [newBtnText]="'member.generic-object.buttons.new' | translate"
      [newBtnDisabled]="!(hasPermission('inviteMember') | async)"
      [emptyTitle]="'member.generic-object.empty.title' | translate"
      [emptyDescription]="'member.generic-object.empty.description' | translate"
      (loadMore)="loadMoreMembers($event)"
      [allItemsLoaded]="areAllMembersLoaded$ | async"
      [limit]="queryParams.limit"
      [isError]="membersError$ | async"
    >
      <ng-template templateName="listItem" let-item>
        <member-list-item [item]="item"></member-list-item>
      </ng-template>
    </generic-list>
    <xp-modal
      [isOpen]="isModalOpen$ | async"
      [closeButtonText]="'member.generic-object.buttons.close' | translate"
      [saveButtonText]="'member.generic-object.buttons.save' | translate"
      [titleText]="'member.generic-object.title' | translate"
      (close)="onModalClose()"
    >
      <ng-template>
        <member-form></member-form>
      </ng-template>
    </xp-modal>
  `,
})
export class MembersListComponent implements AfterViewInit {
  type = GenericListType.members;
  membersLoading$ = this.store.select(selectMembersLoadingFlag);
  membersError$ = this.store.select(selectMembersErrorFlag);
  isModalOpen$ = this.store.select(selectMembersIsModalOpenFlag);
  members$ = this.store.select(selectMembers);
  areAllMembersLoaded$ = this.store.select(selectAreAllMembersLoadedFlag);
  queryParams = QueryParamsMembersList;

  constructor(
    @Inject('$rootScope') private $rootScope: any,
    private store: Store<AppState>,
    private permissionsService: PermissionsService,
  ) {
    this.store.dispatch(getMembersList({ params: this.queryParams }));
  }

  ngAfterViewInit() {
    if (this.$rootScope.stateIs('app.account.settings.account.members.new')) {
      this.openCreateModal();
    }
  }

  // eslint-disable-next-line class-methods-use-this
  openCreateModal(): void {
    this.$rootScope.stateGo('app.account.settings.account.members.new');
    this.store.dispatch(openMembersModal());
  }

  onModalClose(): void {
    this.$rootScope.stateGo('app.account.settings.account.members');
    this.store.dispatch(closeMembersModal());
  }

  loadMoreMembers(query: LoadMoreQuery) {
    const params: any = {
      ...this.queryParams,
      ...query,
    };
    this.store.dispatch(loadMoreMembersList({ params }));
  }

  hasPermission(permissionName) {
    return this.permissionsService.hasPermission(permissionName);
  }
}

((window as any).xplenty as angular.IModule).directive(
  'membersList',
  downgradeComponent({
    component: MembersListComponent,
  }),
);
